
import axios, { AxiosResponse } from 'axios'
import { AuthDecodedUserType } from 'context/types'
import jwt_decode from 'jwt-decode'

import { GenericResponse } from './types'

type RefreshResponseType = {
  accessToken: string
}

let refreshTokenPromise: Promise<AxiosResponse<GenericResponse<RefreshResponseType>>> | null = null
let flag = false

export const api = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const handleRefreshToken = async (
  refreshToken: string | null,
): Promise<AxiosResponse<GenericResponse<RefreshResponseType>>> => {
  const data = { refreshToken }

  return api.post<GenericResponse<RefreshResponseType>>('Auth/RefreshToken', data)
}

api.interceptors.request.use(async config => {
  if (config.url === 'Auth/PasswordRecoveryChange') return config

  const token = localStorage.getItem('ACCESSTOKEN')

  if (token) config.headers.common.Authorization = `Token ${token}`
  else delete config.headers.common.Authorization

  return config
})

const logout = async () => {
  const refreshToken = localStorage.getItem('REFRESHTOKEN')

  if (refreshToken) {
    const data = {
      refreshToken,
    }

    await api.post<GenericResponse<string>>('Auth/Logout', data)
  }

  localStorage.clear()
  window.location.reload()
}

export const ApiConfigurator = () => {
  setInterval(async () => {
    const token = localStorage.getItem('ACCESSTOKEN')

    if (token) {
      const decodedToken: AuthDecodedUserType = jwt_decode(token)

      if (decodedToken.exp * 1000 < Date.now() && !refreshTokenPromise && !flag) {
        flag = true

        const refreshTokenValue = localStorage.getItem('REFRESHTOKEN')

        refreshTokenPromise = handleRefreshToken(refreshTokenValue)
        refreshTokenPromise
          .then(response => {
            refreshTokenPromise = null
            flag = false
            localStorage.setItem('ACCESSTOKEN', response?.data.payload.accessToken || '')

            return response?.data.payload.accessToken
          })
          .catch(() => {
            refreshTokenPromise = null
            flag = false
          })
      }
    }
  }, 10000)

  api.interceptors.response.use(
    response => response,
    async error => {
      if (error.config && error.response?.status === 401) {
        if (error.config.url === 'Auth/RefreshToken') logout()

        if (!refreshTokenPromise) {
          const refreshTokenValue = localStorage.getItem('REFRESHTOKEN')

          refreshTokenPromise = handleRefreshToken(refreshTokenValue)
          refreshTokenPromise.then(async response => {
            refreshTokenPromise = null
            localStorage.setItem('ACCESSTOKEN', response?.data.payload.accessToken || '')

            return response?.data.payload.accessToken
          })
        }

        return refreshTokenPromise.then(async response => {
          const token = response?.data?.payload?.accessToken

          if (token) {
            error.config.headers.Authorization = `Token ${token}`

            return api(error.config)
          }

          return Promise.reject(error)
        })
      }

      return Promise.reject(error)
    },
  )
}

